import { createStore } from 'vuex'

import annotationList from '../data/hotspots.js'

// import filterList from '../data/filter.js'

export default createStore({
  state: {
    annotation: null, // id of content modal
    navShowing: false,
    showAnnotation: false,
    zoomId: null, // did we just click a hotspot to load a second screen?
    zoomState: 'out' // in or out?
  },
  mutations: {
    setAnnotation (state, payload) {
      state.annotation = payload
    },
    setNavShowing (state, payload) {
      state.navShowing = payload
    },
    setShowAnnotation (state, payload) {
      state.showAnnotation = payload
    },
    setZoomId (state, payload) {
      state.zoomId = payload
    },
    setZoomState (state, payload) {
      state.zoomState = payload
    }
  },
  getters: {
    getAnnotation: state => {
      return state.annotation
    },
    getHotspots: state => {
      return annotationList.hotspots
    },
    getNavShowing: state => {
      return state.navShowing
    },
    getShowAnnotation: state => {
      return state.showAnnotation
    },
    getZoomId: state => {
      return state.zoomId
    },
    getZoomState: state => {
      return state.zoomState
    }
  },
  actions: {
  },
  modules: {
  }
})
